export const ISSUE_REPORT_DESCRIPTION_MAX_LEN = 2000
